import Link from 'next/link';
import { useSession } from 'next-auth/react';
import { Search } from '@eqi-investimentos/icons/web';
import { Flex, IconButton } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { salesforceOpportunityConfig } from '@/config/salesForce';
import { useSendClickEvent } from '@/modules/Customer/http/client/mutations/useSendClickEvent';
import { NotificationsButton } from './NotificationsButton';

export const RightActions = () => {
  const { data: session } = useSession();
  const unauthorized = !session || !session.access_token;

  const { mutate: sendClickEvent } = useSendClickEvent();

  const onClickLink = () => {
    if (unauthorized) {
      window.dispatchEvent(new Event('open-unauthenticated-modal'));
    }

    sendClickEvent({
      label: salesforceOpportunityConfig.sendClickEvent.search.label(
        window.location.pathname
      ),
    });
  };

  return (
    <Flex
      justifyContent="flex-end"
      alignItems="center"
      w="full"
      gap="xs"
      sx={{
        '& > a': {
          opacity: unauthorized ? 0.5 : 1,
        },
      }}
    >
      <Link
        aria-label="button-go-to-search-screen"
        href={unauthorized ? '#' : PATHS?.search}
      >
        <IconButton
          aria-label="Pesquisar"
          icon={<Search color="content.brand" boxSize="1.5rem" />}
          variant="naked"
          p="xs"
          bgColor="transparency.light"
          borderRadius="50%"
          onClick={(e) => {
            if (unauthorized) {
              e.stopPropagation();
            }
            onClickLink();
          }}
        />
      </Link>
      <NotificationsButton />
    </Flex>
  );
};
